export enum TaskState {
  Initial,
  Pending,
  Success,
  Error,
}
